import { ArcAuthConfig } from "@arcauth/react-sdk";

export const configMap: {
  [key: string]: { clientID: string; serverUrl: string; redirectUri: string };
} = {
  // ARCHIVES
  "086648b5-3e54-4622-917c-62936d02983a": {
    clientID: "086648b5-3e54-4622-917c-62936d02983a", // The client ID of your ArcAuth application, e.g.,
    // serverUrl: 'http://10.10.85.46:30000/tokenexchange', // The URL of your server that performs the token exchange
    serverUrl: "https://stgauthtoken.skysite.com/tokenexchange",
    redirectUri: "https://stgprofile.skysite.com", // Where to redirect to your React client after authentication
    //redirectUri: 'http://localhost:5000',
  },
  // FACILITIES
  "d69c6394-60cb-44fb-b8be-f57776d8a14e": {
    clientID: "d69c6394-60cb-44fb-b8be-f57776d8a14e",
    serverUrl:
      "http://inkovm-k8sm1.mptdc1-india.mirrorplus.com:30000/tokenexchange",
    // redirectUri: 'https://stgprofile.arcfacilities.com',
    redirectUri: "http://inkovm-lafcd01.mptdc1-india.mirrorplus.com:8080",
  },
  // API HUB
  "bd8c0793-f214-4771-9a8e-368c14791d7a": {
    clientID: "bd8c0793-f214-4771-9a8e-368c14791d7a",
    serverUrl:
      "http://inkovm-k8sm1.mptdc1-india.mirrorplus.com:30000/tokenexchange",
    // redirectUri: 'https://stgprofile.arcfacilities.com',
    redirectUri: "http://inkovm-lafcd01.mptdc1-india.mirrorplus.com:8080",
  },

  // ARC Capture
  "c16c91cb-e2ee-480e-b0cf-25c255aca72a": {
    clientID: "c16c91cb-e2ee-480e-b0cf-25c255aca72a",
    serverUrl: "https://stgauthtoken.arcfacilities.com/tokenexchange",
    redirectUri: "https://stgprofile.skysite.com",
  },
  // ARC Admin
  "5dfd0870-ede2-43c4-be4c-9a947a425c69": {
    clientID: "5dfd0870-ede2-43c4-be4c-9a947a425c69",
    serverUrl: "https://stgauthtoken.skysite.com/tokenexchange",
    redirectUri: "https://stgprofile.skysite.com",
  },
  // ARC PRINT
  "8fe255fe-09f2-4845-a6b6-6243d1a1bcd3": {
    clientID: "8fe255fe-09f2-4845-a6b6-6243d1a1bcd3",
    serverUrl: "https://stgauthtoken.skysite.com/tokenexchange",
    redirectUri: "https://stgprofile.skysite.com",
  },
  // ARC PRINT IND
  "3706fb99-b27c-46d0-9277-8560ad0223b6": {
    clientID: "3706fb99-b27c-46d0-9277-8560ad0223b6",
    serverUrl: "https://stgauthtoken.skysite.com/tokenexchange",
    redirectUri: "https://stgprofile.skysite.com",
  },
  // ARC AI SCANNING
  "2c90501c-e6ef-41e3-a81c-2cf395f6e735": {
    clientID: "2c90501c-e6ef-41e3-a81c-2cf395f6e735",
    serverUrl: "https://stgauthtoken.skysite.com/tokenexchange",
    redirectUri: "https://stgprofile.skysite.com",
  },
  // ARC MONITORING
  "0a1cd4cc-bbdd-48da-b9f6-b53d15cd7bcc": {
    clientID: "0a1cd4cc-bbdd-48da-b9f6-b53d15cd7bcc",
    serverUrl: "https://stgauthtoken.skysite.com/tokenexchange",
    redirectUri: "https://stgprofile.skysite.com",
  },
  // add more configurations as needed...
};

export function getConfig(clientID: string): ArcAuthConfig {
  return configMap[clientID];
}
